export const MENU_SORT_OPTIONS = [
  { value: "manual", label: "Manual" },
  { value: "name_asc", label: "Nombre A → Z" },
  { value: "name_desc", label: "Nombre Z → A" },
  { value: "price_asc", label: "Precio menor → mayor" },
  { value: "price_desc", label: "Precio mayor → menor" },
];

const VALID_SORT_MODES = new Set(MENU_SORT_OPTIONS.map((option) => option.value));

export function normalizeMenuSortMode(value) {
  return VALID_SORT_MODES.has(value) ? value : "manual";
}

export function parseMenuPrice(value) {
  const compact = String(value ?? "").replace(/[^\d,.-]/g, "");
  if (!compact) return null;

  const lastComma = compact.lastIndexOf(",");
  const lastDot = compact.lastIndexOf(".");
  let normalized = compact;

  if (lastComma >= 0 && lastDot >= 0) {
    const decimalSeparator = lastComma > lastDot ? "," : ".";
    const thousandsSeparator = decimalSeparator === "," ? "." : ",";
    normalized = normalized.split(thousandsSeparator).join("");
    if (decimalSeparator === ",") normalized = normalized.replace(",", ".");
  } else if (lastComma >= 0) {
    normalized = normalized.replace(",", ".");
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function sortMenuItems(items, sortMode) {
  const mode = normalizeMenuSortMode(sortMode);
  const decorated = items.map((item, index) => ({ item, index }));

  decorated.sort((a, b) => {
    if (mode === "manual") {
      const aOrder = Number(a.item.order);
      const bOrder = Number(b.item.order);
      const orderDifference = (Number.isFinite(aOrder) ? aOrder : 0) - (Number.isFinite(bOrder) ? bOrder : 0);
      return orderDifference || a.index - b.index;
    }

    if (mode === "name_asc" || mode === "name_desc") {
      const comparison = String(a.item.name || "").localeCompare(String(b.item.name || ""), "es", {
        sensitivity: "base",
      });
      return (mode === "name_desc" ? -comparison : comparison) || a.index - b.index;
    }

    const aPrice = parseMenuPrice(a.item.price);
    const bPrice = parseMenuPrice(b.item.price);
    if (aPrice == null && bPrice == null) return a.index - b.index;
    if (aPrice == null) return 1;
    if (bPrice == null) return -1;
    const comparison = aPrice - bPrice;
    return (mode === "price_desc" ? -comparison : comparison) || a.index - b.index;
  });

  return decorated.map(({ item }) => item);
}
